import {
  Box,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
  useTheme
} from "@mui/material";

import {
  BCPArrowLeft,
  BCPLinkSimple
} from "../../../components/icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../../global/environmentVariables";

export default function OrganizationWidgets(props) {
  const { organization } = props;
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container sx={{ gap: 2, p: 2 }}>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Link
              href="/organize/game-stores"
              color="link.main"
              sx={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start"
              }}
            >
              <BCPArrowLeft
                sx={{ "padding-right": "1rem", "padding-bottom": "2px" }}
              />{" "}
              Back to My Organizations
            </Link>
          </Grid>

          <Grid item xs={12} md={9}>
            <Typography
              variant="h2"
              component="h3"
              fontWeight="700"
              gutterBottom
            >
              Embed
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                Organization Links
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Landing Page"
                  value={`${window.location.origin}/organization/${organization?.id}?embed=true`}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Copy Landing Page"
                          edge="end"
                          color={
                            theme?.palette?.mode === "dark" ? "" : "primary"
                          }
                          onClick={() => {
                            navigator.clipboard.writeText(
                              `${window.location.origin}/organization/${organization?.id}?embed=true`
                            );
                          }}
                        >
                          <BCPLinkSimple />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              {!getEnvironmentVariable("HIDE_RANKINGS") && (
                <Grid item xs={12}>
                  <TextField
                    label="Rankings Page"
                    value={`${window.location.origin}/organization/rankings/${organization?.id}`}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Copy Rankings Page"
                            edge="end"
                            color={
                              theme?.palette?.mode === "dark" ? "" : "primary"
                            }
                            onClick={() => {
                              navigator.clipboard.writeText(
                                `${window.location.origin}/organization/rankings/${organization?.id}`
                              );
                            }}
                          >
                            <BCPLinkSimple />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  label="Events Page"
                  value={`${window.location.origin}/organization/events/${organization?.id}?embed=true`}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Copy Events Page"
                          edge="end"
                          color={
                            theme?.palette?.mode === "dark" ? "" : "primary"
                          }
                          onClick={() => {
                            navigator.clipboard.writeText(
                              `${window.location.origin}/organization/events/${organization?.id}?embed=true`
                            );
                          }}
                        >
                          <BCPLinkSimple />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Events Search with Token Types"
                  value={`${window.location.origin}/play/events?orgId=${organization?.id}`}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Copy Events with Token Types Page"
                          edge="end"
                          color={
                            theme?.palette?.mode === "dark" ? "" : "primary"
                          }
                          onClick={() => {
                            navigator.clipboard.writeText(
                              `${window.location.origin}/play/events?orgId=${organization?.id}`
                            );
                          }}
                        >
                          <BCPLinkSimple />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Events Search with Token Types"
                  value={`${window.location.origin}/play/events?orgId=${organization?.id}`}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Copy Events with Token Types Page"
                          edge="end"
                          color={
                            theme?.palette?.mode === "dark" ? "" : "primary"
                          }
                          onClick={() => {
                            navigator.clipboard.writeText(
                              `${window.location.origin}/play/events?orgId=${organization?.id}`
                            );
                          }}
                        >
                          <BCPLinkSimple />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Token Request Page"
                  value={`${window.location.origin}/organization/token-request/${organization?.id}?embed=true`}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Copy Token Request Page"
                          edge="end"
                          color={
                            theme?.palette?.mode === "dark" ? "" : "primary"
                          }
                          onClick={() => {
                            navigator.clipboard.writeText(
                              `${window.location.origin}/organization/token-request/${organization?.id}?embed=true`
                            );
                          }}
                        >
                          <BCPLinkSimple />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
